import { AbstractControl,  ValidationErrors, ValidatorFn } from '@angular/forms';

export const matchPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const newPassword = control.get('newPassword');
  const confirm = control.get('passwordConfirm');

  return newPassword && confirm  && newPassword.value && confirm.value && newPassword.value != confirm.value ? { passwordMatchError: true } : null;
};

export const reuseValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const newPassword = control.get('newPassword');
  const currentPassword = control.get('currentPassword');

  return newPassword && currentPassword && newPassword.value && currentPassword.value && newPassword.value === currentPassword.value ? { passwordReused: true } : null;
};

export const PasswordStrength: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  let value: string = control.value || '';
  if (!value) {
    return null;
  }

  let upperCaseCharacters = /[A-Z]+/;
  let lowerCaseCharacters = /[a-z]+/;
  let numberCharacters = /[0-9]+/;

  if (upperCaseCharacters.test(value) === false || lowerCaseCharacters.test(value) === false || numberCharacters.test(value) === false) {
    return { passwordStrength: true };
  } else {
    return null;
  }
};

export const SpecialChar: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  let value: string = control.value || '';
  if (!value) {
    return null;
  }

  let specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  if(specialCharacters.test(value) === false){
    return { specialCharacterValid: true };
  } else {
    return null;
  }
};